import {
  Grid2,
  InputAdornment,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import { FastField, Field } from "formik";
import React, { useState } from "react";
import "tippy.js/dist/tippy.css";
import CommonButton from "../../../../../component/Button";
import {
  CommonGrid2,
  StyledFlexColumnView,
} from "../../../../common-components/StyledComponents";
import SkillTable from "./SkillTable";
import DropDownSelect from "../../../../../component/Select";
import { StyledSpaceBetweenBox } from "../../../../matches/quick-match/components/StyledComponent";
import { CustomPaper } from "../../../../resume-intelligence/Style";
import CommonTextField from "../../../../../component/Input";
import { AutoAwesome } from "@mui/icons-material";
import Haley from "../../../../../assets/images/Haley.png";

// const skillDropDown = [
//   { name: "SalesForce Project Manager", id: 1 },
//   { name: "Salesforce Business Analyst/Administrator", id: 2 },
//   { name: "Salesforce Developer", id: 3 },
//   { name: "Salesforce Architect", id: 4 },
//   { name: "Salesforce Quality Assurance Analyst", id: 5 },
// ];

const Skills = ({
  alignment,
  handleAddNewSkill,
  jobModifyData,
  handleSkillToogleChange,
  handleSkillTextChange,
  isLoading,
  highPriority,
  lowPriority,
  mediumPriority,
  recommended,
  headerData,
  handleDeleteSkillRow,
  isShownHeaderTitle,
  isMargin,
  isToggle,
  skillDropDownData,
  skillDropDown,
  handleSkillDropDown,
}) => {
  // const [skillDropDownData, setSkillDropDownData] = useState(
  //   skillDropDown[0]?.name
  // );
  const skillSections = [
    {
      title: "Functional Expertise (Core)",
      fieldName:
        skillDropDownData === "Salesforce Project Manager"
          ? "medium_priority"
          : skillDropDownData === "Salesforce Business Analyst/Administrator"
          ? "high_priority"
          : skillDropDownData === "Salesforce Developer"
          ? "low_priority"
          : skillDropDownData === "Salesforce Architect"
          ? "salesforce_architect"
          : skillDropDownData === "Salesforce Quality Assurance Analyst"
          ? "salesforce_quality_assurance_analyst"
          : skillDropDownData === "DevOps Personnel"
          ? "devOps_personnel"
          : "recommended",
      rowData: highPriority,
      scoreFieldName: "score_hard_skills",
    },
  ];

  console.log(skillDropDownData, "skillDropDownData");
  return (
    <>
      <Grid2
        container
        spacing={3}
        sx={{ display: "flex", alignItems: "stretch" }}
      >
        {skillSections.map(({ title, fieldName, rowData, scoreFieldName }) => {
          return (
            <Field>
              {({ form }) =>
                (alignment === "Edit"
                  ? form?.values?.["skillData"]?.[fieldName]?.length !== 0
                  : rowData?.length !== 0) && (
                  <>
                    {isShownHeaderTitle ? (
                      <Grid2 size={12}>
                        <Typography
                          sx={{
                            fontSize: "20px",
                            color: "#101828",
                            fontWeight: 600,
                            marginTop: isMargin ? "30px" : "",
                          }}
                        >
                          {"Skills by Role"}
                        </Typography>
                      </Grid2>
                    ) : null}

                    <Grid2 size={12}>
                      <DropDownSelect
                        marginTop="0px"
                        // title="Select Highest Level of Education"
                        removeAnimation={true}
                        value={skillDropDownData} // Single value for industry
                        // onChange={(e) => console.log(e)}
                        // handleChange={(e, selectedOption) => {
                        //   console.log(e);
                        //   console.log(selectedOption, "selectedOption");
                        //   setSkillDropDownData(e.target.value);
                        // }}
                        handleChange={handleSkillDropDown}
                        // onChange={(e) => setSkillDropDownData(e.target.value)} // Update industry value directly
                        data={skillDropDown}
                        customStyle={{ width: "300px" }}
                      />
                    </Grid2>

                    <Grid2 size={7} sx={{ height: "100%" }}>
                      {isToggle ? (
                        <StyledSpaceBetweenBox>
                          <Typography variant="h5" fontWeight={500}>
                            {title}
                          </Typography>
                          {alignment === "Edit" && (
                            <Field name={scoreFieldName}>
                              {({ field, form }) => (
                                <Switch
                                  checked={form.values[scoreFieldName]}
                                  onChange={(event) =>
                                    form.setFieldValue(
                                      scoreFieldName,
                                      event.target.checked
                                    )
                                  }
                                />
                              )}
                            </Field>
                          )}
                        </StyledSpaceBetweenBox>
                      ) : null}

                      <SkillTable
                        // rowData={
                        //   alignment === "Edit"
                        //     ? form?.values?.["skillData"]?.[fieldName]
                        //     : rowData
                        // }
                        rowData={form?.values?.["skillData"]?.[fieldName]}
                        name={fieldName}
                        jobModifyData={jobModifyData}
                        handleSkillToogleChange={handleSkillToogleChange}
                        headerData={headerData}
                        handleDeleteSkillRow={handleDeleteSkillRow}
                        handleSkillTextChange={handleSkillTextChange}
                        alignment={alignment}
                        isLoading={isLoading}
                        form={form}
                      />
                    </Grid2>
                    <Grid2 size={5} sx={{ minHeight: "100%" }}>
                      <CustomPaper
                        variant="outlined"
                        width="100%"
                        padding={"16px"}
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          justifyContent: "start",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "20px",
                            fontWeight: 600,
                            color: "#344054",
                            marginBottom: "28px",
                          }}
                        >
                          Deliverables
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: 500,
                            color: "#475467",
                            lineHeight: "1.5",
                            // width: "100%",
                          }}
                        >
                          {`A ${skillDropDownData} is responsible for overseeing the implementation, customization, and optimization of Salesforce solutions. Their deliverables typically fall into the following categories, Project Planning & Initiation, Requirements Gathering & Analysis.`}
                        </Typography>
                      </CustomPaper>
                    </Grid2>
                  </>
                )
              }
            </Field>
          );
        })}

        <Grid2 item size={{ xs: 12 }}>
          <CommonTextField
            border={"0.5px solid #EAECF0"}
            padding={15}
            placeholder={"Ask Haley anything"}
            bgColor={"#F7F8F9"}
            startIcon={
              <InputAdornment position="start">
                <img src={Haley} />
              </InputAdornment>
            }
            endComponent={
              <CommonButton
                // onClick={() => setAi(!ai)}
                fontWeight={600}
                padding={"8px 25px"}
                value={"Ask Haley"}
                endIcon={<AutoAwesome />}
              />
            }
          />
        </Grid2>
        {/* <CommonGrid2 width={"max-content"}>
          <CommonButton
            variant="outlined"
            color="#344054"
            border="#D0D5DD"
            padding="9px 20px"
            fontWeight="600"
            value="Add New"
            onClick={() => handleAddNewSkill(form)}
          />
        </CommonGrid2> */}
      </Grid2>

      {alignment === "Edit" && (
        <Field name="skillData">
          {({ form }) => {
            return (
              <Tooltip
                className={form?.errors?.["checkcondition"] && "Mui-error"}
                open={form?.errors?.["checkcondition"] ? true : false}
                title={form?.errors?.["checkcondition"]}
                arrow
                zIndex={9}
                placement="right"
                PopperProps={{
                  sx: {
                    zIndex: 1300,
                  },
                }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "red",
                      "& .MuiTooltip-arrow": {
                        "&::before": {
                          backgroundColor: "red",
                        },
                      },
                    },
                  },
                }}
              >
                <CommonGrid2 width={"max-content"} sx={{ marginTop: "20px" }}>
                  <CommonButton
                    variant="outlined"
                    color="#344054"
                    border="#D0D5DD"
                    padding="9px 20px"
                    fontWeight="600"
                    value="Add New"
                    onClick={() => handleAddNewSkill(form)}
                  />
                </CommonGrid2>
              </Tooltip>
            );
          }}
        </Field>
      )}
    </>
  );
};

export default Skills;
